// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getStorage } from '../utils/functions/localstorage';
// Define a service using a base URL and expected endpoints
const baseQuery = fetchBaseQuery({
  baseUrl: `${process.env.REACT_APP_API_URL}/transfer-slip`,
  prepareHeaders: (headers) => {
    const token = getStorage('token');

    // If we have a token set in state, let's assume that we should be passing it.
    if (token) {
      headers.set('authorization', `Bearer ${token}`);
    }

    return headers;
  },
});

export const transferSlipApi = createApi({
  reducerPath: 'transferSlipApi',
  baseQuery,
  endpoints: (builder) => ({
    getInvSlip: builder.query({
      query: (q) => `/get-invoice-slip/?sorgcode=${q.sorgcode}&soldToParty=${q.customerCode}`,
    }),
    getTransSlip: builder.query({
      query: (q) => `/get-transaction-slip/?sorgcode=${q.sorgcode}`,
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetInvSlipQuery, useGetTransSlipQuery } = transferSlipApi;
